import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { organisationsAPI } from '../api/organisationsAPI';
import { organisationErrorMessage } from '../lib/errorMessage';
import { leavingLabel, londonToday, yearGroupFor } from '../lib/schoolYears';
import { JOIN_PATH } from '../pendingJoinCode';
import './MyOrganisationPanel.css';

const ROLE_LABELS = { student: 'Student', staff: 'Staff' };

/** What the signed-in user belongs to, as GET /api/organisations/me says. */
const Membership = ({ membership }) => (
  <div className="entry-card">
    <div className="entry-header">
      <h4>{membership.organisation.name}</h4>
    </div>
    <dl className="my-organisation__facts">
      <div>
        <dt>Role</dt>
        <dd>{ROLE_LABELS[membership.role] || membership.role}</dd>
      </div>
      {membership.role === 'student' ? (
        <div>
          <dt>Leaving year</dt>
          <dd>
            {membership.cohort_year == null
              ? 'Not set yet'
              : leavingLabel(membership.cohort_year, yearGroupFor(membership.cohort_year, londonToday()))}
          </dd>
        </div>
      ) : null}
      <div>
        <dt>Groups</dt>
        <dd>{membership.groups.length ? membership.groups.map((g) => g.name).join(', ') : 'None'}</dd>
      </div>
    </dl>
  </div>
);

/**
 * Profile → School: read-only. Membership is changed only by joining with a
 * code (/join) and by staff on the dashboard, never from here.
 */
const MyOrganisationPanel = () => {
  const [me, setMe] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;
    organisationsAPI.me()
      .then((data) => { if (!cancelled) setMe(data); })
      .catch((err) => {
        if (!cancelled) setError(organisationErrorMessage(err, 'Could not load your school. Please try again.'));
      });
    return () => { cancelled = true; };
  }, []);

  let body = <p>Loading…</p>;
  if (error) {
    body = <div className="error-message">{error}</div>;
  } else if (me?.membership) {
    body = <Membership membership={me.membership} />;
  } else if (me?.is_platform_admin) {
    body = <div className="empty-state"><p>Platform admin accounts manage every school without joining one.</p></div>;
  } else if (me) {
    body = (
      <div className="empty-state">
        <p>You are not part of a school on PathBuddy.</p>
        <p>If your school gave you a link or a code, <Link to={JOIN_PATH}>join your school</Link>.</p>
      </div>
    );
  }

  return (
    <div className="profile-section">
      <div className="section-header">
        <div className="section-header-info">
          <h2>School</h2>
          <p>The school you belong to, your leaving year and your groups.</p>
        </div>
      </div>
      {body}
    </div>
  );
};

export default MyOrganisationPanel;
